<header class="header">
  <div class="header-left">
    <button class="menu-toggle" (click)="onToggleSidebar()" [attr.aria-label]="'common.menu' | translate">
      <lucide-icon name="menu" [size]="24"></lucide-icon>
    </button>
    <div class="logo-container">
      <img [src]="themeService.isDark ? 'assets/logo-dark.png' : 'assets/logo.png'" [alt]="'common.logoAlt' | translate" class="logo-image">
    </div>
  </div>
  
  <div class="header-right">
    <div class="user-info" *ngIf="currentUser$ | async as user">
      <div class="notification-dropdown" *ngIf="showBell">
        <button class="notification-btn" (click)="onNotificationClick($event)" type="button"
                aria-haspopup="menu" [attr.aria-expanded]="notificationDropdownOpen"
                [attr.aria-label]="'layout.header.notifications' | translate">
          <lucide-icon name="bell" [size]="20"></lucide-icon>
          <span *ngIf="unreadCount > 0" class="notification-badge" aria-live="polite" aria-atomic="true">{{ unreadCount >= 100 ? '99+' : unreadCount }}</span>
        </button>

        <app-notification-bell-dropdown
          *ngIf="notificationDropdownOpen"
          [communicationCount]="unreadCount"
          (navigate)="onNotificationCategoryClick()">
        </app-notification-bell-dropdown>
      </div>

      <!-- Toggle Tema -->
      <button class="theme-toggle-btn" (click)="onToggleTheme()" type="button"
              [attr.aria-label]="themeService.isDark ? 'Tema claro' : 'Tema escuro'">
        <!-- Sol (mostrado no dark mode) -->
        <lucide-icon *ngIf="themeService.isDark" name="sun" [size]="20"></lucide-icon>
        <!-- Lua (mostrado no light mode) -->
        <lucide-icon *ngIf="!themeService.isDark" name="moon" [size]="20"></lucide-icon>
      </button>

      <!-- User Profile com Dropdown -->
      <div class="user-profile-dropdown">
        <button class="user-profile-trigger" (click)="toggleDropdown($event)" type="button">
          <div class="user-avatar" [class.has-photo]="userPhotoUrl">
            <img 
              *ngIf="userPhotoUrl" 
              [src]="userPhotoUrl" 
              [alt]="user.name"
              class="avatar-image"
              (error)="userPhotoUrl = null">
            <span *ngIf="!userPhotoUrl" class="avatar-initials">{{ userInitials }}</span>
          </div>
          <div class="user-details">
            <span class="user-name" [appTooltip]="user.name" tooltipPosition="bottom">{{ truncatedName }}</span>
            <span class="user-system">{{ (laboratoryRazaoSocial$ | async) || ('layout.header.systemName' | translate) }}</span>
          </div>
          <lucide-icon class="chevron-icon" [class.open]="dropdownOpen" name="chevron-right" [size]="16"></lucide-icon>
        </button>

        <!-- Dropdown Menu -->
        <div class="dropdown-menu" *ngIf="dropdownOpen">
          <button class="dropdown-item logout-item" (click)="onLogout()">
            <lucide-icon name="log-out" [size]="16"></lucide-icon>
            <span>{{ 'layout.header.logout' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
